<!-- main app container -->
<router-outlet></router-outlet>

<simple-notifications [options]="options" (onCreate)="onCreate($event)" (onDestroy)="onDestroy($event)"></simple-notifications>

<ngx-spinner bdColor = "rgba(51, 51, 51, 0.8)" size = "large" color = "#fff" type = "line-scale-party"></ngx-spinner>
